import { Injectable } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot} from '@angular/router';
import { CampaignFacadeService } from '@uw/core/facades/campaign.facade.service';
import { Campaign, CampaignInfo} from '@uw/core/models/campaign.model';
import { CampaignStateService } from '@uw/core/services/campaign-state.service';
import { CampaignService } from '@uw/core/services/campaign.service';
import { Observable, of, catchError, map, mergeMap, take, tap } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { CustomNavigationService } from '../custom-navigation.service';

@Injectable({
  providedIn: 'root'
})
export class CurrentCampaignsResolver  {
  guid!: string | null;
  kioskId: string  = null;
  uwId: string = null;

  constructor(private campaignService: CampaignService,
    private campaignStateService: CampaignStateService,
    private campaignFacadeService: CampaignFacadeService,
    private customNavigationService: CustomNavigationService,
    private authService: AuthService){

   }


  resolve(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot,): Observable<any> {
    this.guid = route.paramMap.get("cguid");
    this.kioskId = route.queryParams.kiosk;
    this.uwId = route.queryParams.uw;
    this.campaignStateService.setKioskId(this.kioskId);
    this.campaignStateService.setUWId(this.uwId);

    if (!this.guid) {
      this.redirectUser();
    }

    return this.campaignFacadeService.getCurrentCampaign()
    .pipe(
      take(1),
      mergeMap(c=>  {
        if (c){
          this.redirectForLightCampaing(c);
        }
        return c ? of(true) : this.loadCampaingFromQueryString();
      }),
      map(_c=> true)
    );
    //return this.loadCampaingFromQueryString();
  }

  loadCampaingFromQueryString(): Observable<Campaign | null> {
    if (this.guid) {
     return this.campaignService.getCampaingInfo(this.guid).pipe(tap(camp=> {
      this.campaignStateService.setSelectedCampaign(camp.info);
      this.campaignFacadeService.setCurrentCampaign(camp.info);
      this.campaignStateService.setKioskId(this.kioskId);
      this.campaignStateService.setUWId(this.uwId);
      this.redirectForLightCampaing(camp.info);
     }),
     catchError(( error: any) => {
      this.redirectUser();
      return of(null);
     }));
    } else {
      this.redirectUser();
      return of(null);
    }
}


redirectUser(){
  if (this.authService.isUserLoggedId()){
    this.customNavigationService.navigate(['/donor-info']);
  } else {
    this.customNavigationService.navigate(['/main','login']);
  }
}


redirectForLightCampaing(_campaignInfo: CampaignInfo){
  // if (campaignInfo.liteCampaignType === LiteCampaignTypes.Kiosk && !this.kioskId){
  //   this.customNavigationService.navigate(['/main', 'campaign', campaignInfo.campaignGuid, 'select-kiosk']);
  // } else if (campaignInfo.liteCampaignType === LiteCampaignTypes.National && !this.uwId){
  //   // commented out following line to allow navigation incase uwId is not provided. devops #1039 
  //   // this.customNavigationService.navigate(['/main', 'campaign', campaignInfo.campaignGuid, 'select-uw']);
  // }

  // if (this.kioskId && !this.isNumber(this.kioskId)){
  //   this.customNavigationService.navigate(['/main', 'campaign', campaignInfo.campaignGuid, 'select-kiosk']);
  // }
}

isNumber(value: string | number): boolean
{
   return ((value != null) &&
           (value !== '') &&
           !isNaN(Number(value.toString())));
}

}
